import { Link } from 'react-router-dom';
import './Home.css';
import { useState } from 'react';
import InstantBooking from '../components/InstantBooking';
import medImage from '../assets/med.jpg';
import drImage from '../assets/dr.jpg';
import ambImage from '../assets/amb.jpeg';

const services = [
  { 
    title:'Order Medicines', 
    subtitle:'Genuine medicines delivered to you', 
    description:'Get genuine medicines from verified pharmacies with fast home delivery',
    image: medImage, 
    bgColor:'#e0f7f4', 
    route: '/shops',
    btnText: 'Buy Medicines',
    icon: '💊'
  },
  { 
    title:'Doctor Appointment', 
    subtitle:'Book online consultation', 
    description:'Connect with experienced doctors for professional online consultations',
    image: drImage, 
    bgColor:'#e0f2fe', 
    route: '/book-doctor',
    btnText: 'Book Doctor',
    icon: '👨‍⚕️'
  },
  { 
    title:'Ambulance Service', 
    subtitle:'Quick & reliable ambulance', 
    description:'Emergency medical transport with trained paramedics available 24/7',
    image: ambImage, 
    bgColor:'#fef3c7', 
    route: '/ambulance',
    btnText: 'Book Ambulance',
    icon: '🚑'
  },
];

const steps = [
  { n:'01', icon:'🔍', title:'Search', desc:'Browse verified nurses by city, specialization and rating' },
  { n:'02', icon:'📅', title:'Book', desc:'Pick a date, time slot and confirm your booking' },
  { n:'03', icon:'🚗', title:'Nurse Arrives', desc:'Your nurse arrives at your address on time' },
  { n:'04', icon:'⭐', title:'Rate & Review', desc:'Share your experience after the visit' },
];



const stats = [
  { val:'24/7', label:'Always Available', icon:'🕐' },
  { val:'Free', label:'Consultation Support', icon:'💬' },
  { val:'20+', label:'Districts Covered', icon:'🏙️' },
  { val:'Fast', label:'Same-Day Booking', icon:'⚡' },
];

export default function Home() {
  const [showOfferPopup, setShowOfferPopup] = useState(true);
  const [instantOpen, setInstantOpen] = useState(false);

  return (
    <div className="home">
      {/* Offer Popuppppppppppppppp */}
      {/* {showOfferPopup && (
        <div className="offer-popup-overlay">
          <div className="offer-popup">
            <button 
              className="offer-popup-close"
              onClick={() => setShowOfferPopup(false)}
            >
              ✕
            </button>
            <div className="offer-popup-content">
              <div className="offer-header">🎉 OFFER 🎉</div>
              <h3 className="offer-title">Add Your Medical Shop With Us Today!</h3>
              <p className="offer-description">Join SehatSehul and expand your reach to thousands of customers</p>
              <div className="offer-pricing">
                <div className="original-price">Original: ₹199</div>
                <div className="discount-badge">50% OFF</div>
                <div className="final-price">Only ₹99</div>
              </div>
              <p className="offer-note">Limited Time Offer - Register Your Shop Now!</p>
              <Link 
                to="/shops/register" 
                className="btn btn-teal offer-btn"
                onClick={() => setShowOfferPopup(false)}
              >
                Register Your Shop →
              </Link>
            </div>
          </div>
        </div>
      )} */}
      {/* Hero */}
      <section className="hero">
        <div className="hero-bg-shape"/>
        <div className="container hero-inner">
          <div className="hero-text fade-up">
            <div className="hero-tag"> 🏆 Kashmir's #1 Home Healthcare Platform</div>
            <h1>Professional <span>Health Care</span><br/>At Your Doorstep</h1>
            <p>Connect with certified, verified nurses for home visits, IV therapy, wound care, post-operative support, and specialized medical care  available 24/7 across Kashmir.</p>
            <div className="hero-actions">
              <Link to="/nurses" className="btn btn-teal"><span>🔍  </span>  Find a Nurse Now</Link>
              {/* <Link to="/register?role=nurse" className="btn btn-outline"> <span>💼   </span>  Join as Nurse</Link> */}
              <Link to="/book-test" className="btn btn-teal"><span>🧪  </span>  Book Lab Test</Link>
              {/* <Link to="/shops/register" className="btn btn-outline"> <span>➕   </span>  Add Your Shop</Link> */}
              <button className="btn btn-primary" style={{marginLeft:8}} onClick={() => setInstantOpen(true)}>⚡ Book Instant Service</button>
            </div>
            <div className="hero-trust">
              <div className="trust-avatars">
                {['👩','👨','👩','👨','👩'].map((e,i) => <span key={i}>{e}</span>)}
              </div>
              <span>Trusted by <strong>5,000+</strong> families across Kashmir Valley</span>
            </div>
          </div>
          <div className="hero-card fade-up" style={{animationDelay:'.15s'}}>
            <div className="hcard-title">Quick Booking</div>
            <div className="hcard-item">
              <span>📍</span>
              <div><small>Location</small><strong>Srinagar</strong></div>
            </div>
            <div className="hcard-item">
              <span>👩‍⚕️</span>
              <div><small>Service</small><strong>General Nursing</strong></div>
            </div>
            <div className="hcard-item">
              <span>📅</span>
              <div><small>Date</small><strong>Today, ASAP</strong></div>
            </div>
            <Link to="/nurses" className="btn btn-teal" style={{width:'100%',justifyContent:'center'}}>Search Available Nurses</Link>
            <div className="hcard-badges">
              <span>✅ Verified</span>
              <span>🔒 Secure</span>
              <span>⚡ Fast</span>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-bar">
        <div className="container stats-inner">
          {stats.map((s,i) => (
            <div key={i} className="stat">
              <div className="stat-icon">{s.icon}</div>
              <div className="stat-val">{s.val}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Quick Access */}
      <section className="quick-access-section">
        <div className="container">
          <div className="section-head">
            <span className="section-tag">Quick Access</span>
            <h2>Everything You Need, In One Place</h2>
            <p>From medicines to prescription scanning — manage your health needs instantly</p>
          </div>
          <div className="qa-grid">
            <div className="qa-card qa-card--teal">
              <div className="qa-icon">🏪</div>
              <div className="qa-body">
                <h3>Medical Shops</h3>
                <p>Browse verified pharmacies near you, check medicine availability and place orders directly from local shops.</p>
                <Link to="/shops" className="qa-btn qa-btn--teal">View Medical Shops →</Link>
              </div>
            </div>
            <div className="qa-card qa-card--rose">
              <div className="qa-icon">📷</div>
              <div className="qa-body">
                <h3>Scan Prescription</h3>
                <p>Upload or scan your doctor's prescription and get instant help identifying medicines, dosage and alternatives.</p>
                <Link to="/scan" className="qa-btn qa-btn--rose">Scan Now →</Link>
              </div>
            </div>
            <div className="qa-card qa-card--blue">
              <div className="qa-icon">🤖</div>
              <div className="qa-body">
                <h3>SaathiCare</h3>
                <p>Your Healthcare Companion, Anytime.Always There When You Need Care.</p>
                <Link to="/scan" className="qa-btn qa-btn--blue">SaathiCare →</Link>
              </div>
            </div>
            <div className="qa-card qa-card--purple">
              <div className="qa-icon">👨‍⚕️</div>
              <div className="qa-body">
                <h3>Book Doctor</h3>
                <p>Connect with experienced doctors for online consultation and medical advice without leaving your home.</p>
                <Link to="/doctors" className="qa-btn qa-btn--purple">Book Doctor →</Link>
              </div>
            </div>
            <div className="qa-card qa-card--orange">
              <div className="qa-icon">👩‍⚕️</div>
              <div className="qa-body">
                <h3>Book Nurse</h3>
                <p>Hire verified and trained nurses for home visits, IV therapy, wound care and specialized medical support.</p>
                <Link to="/nurses" className="qa-btn qa-btn--orange">Book Nurse →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="services-section">
        <div className="container">
          <div className="services-header">
            <div className="services-header-content">
              <span className="services-badge">Premium Services</span>
              <h2>Our Healthcare Services</h2>
              <p>Comprehensive medical solutions at your fingertips</p>
            </div>
          </div>
          <div className="services-grid">
            {services.map((s,i) => (
              <Link key={i} to={s.route} className="service-card-link">
                <div className="service-card">
                  <div className="service-badge-icon">{s.icon}</div>
                  <div className="service-image" style={{backgroundImage: `url(${s.image})`}}/>
                  <div className="service-overlay"/>
                  <div className="service-card-body">
                    <h3>{s.title}</h3>
                    <p className="service-subtitle">{s.subtitle}</p>
                    <p className="service-description">{s.description}</p>
                    <Link to={s.route} className="service-btn">{s.btnText}</Link>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="services-footer">
            <Link to="/services" className="view-all-services-btn">View All Services →</Link>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="section how-section">
        <div className="container">
          <div className="section-head">
            <span className="section-tag">Simple Process</span>
            <h2>How SehatSehul Works</h2>
            <p>Book professional care in 4 easy steps</p>
          </div>
          <div className="steps-grid">
            {steps.map((s,i) => (
              <div key={i} className="step-card">
                <div className="step-num">{s.n}</div>
                <div className="step-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                {i < steps.length - 1 && <div className="step-arrow">→</div>}
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* CTA */}
      <section className="cta-section">
        <div className="container cta-inner">
          <div>
            <h2>Ready to Book a Nurse?</h2>
            <p>Hundreds of verified nurses available right now in your city.</p>
          </div>
          <div className="cta-btns">
            <Link to="/nurses" className="btn btn-teal">Find Nurses Now</Link>
            <Link to="/register?role=nurse" className="btn btn-outline" style={{color:'white',borderColor:'rgba(255,255,255,.4)'}}>Join as Nurse</Link>
            <Link to="/book-test" className="btn btn-teal">Book Lab Test</Link>
            <Link to="/shops/register" className="btn btn-outline" style={{color:'white',borderColor:'rgba(255,255,255,.4)'}}>Add Your Shop</Link>
          </div>
        </div>
      </section>
      <InstantBooking open={instantOpen} onClose={() => setInstantOpen(false)} />
    </div>
  );
}
